(function () {

	var container = document.querySelector('.main-visual');
	if (!container) return;

	/* fallback values, used until data/kv-config.json is fetched (or if it's missing/unreachable) */
	var DEFAULT_CORNERS = [
		[[2.7, 23.9], [15.3, 26.0], [15.3, 42.1], [2.7, 43.9]],
		[[23.7, 35.1], [36.4, 35.3], [36.3, 46.2], [23.7, 45.4]],
		[[43.6, 22.2], [50.9, 22.2], [50.9, 31.0], [43.6, 30.9]],
		[[30.1, 17.8], [37.9, 17.5], [38.0, 30.2], [29.9, 30.2]],
		[[78.4, 13.7], [90.4, 13.5], [90.4, 30.8], [78.3, 30.8]],
		[[79.2, 34.9], [90.8, 35.0], [90.8, 46.9], [79.2, 47.1]]
	];

	var DEFAULT_PATTERNS = [
		{
			s1: { text: 'Paint It.', color: '#f6ab00', bg: '#000000' },
			s2: { text: '', color: '#f6ab00', bg: '#000000' },
			s3: { text: '街を彩り、デザインする。', color: '#ffffff', bg: '#000000' },
			s4: { text: '', color: '#f6ab00', bg: '#000000' },
			s5: { text: 'Design It.', color: '#f6ab00', bg: '#000000' },
			s6: { text: '', color: '#f6ab00', bg: '#000000' }
		},
		{
			s1: { text: 'Paint It.', color: '#000000', bg: '#f6ab00' },
			s2: { text: '', color: '#f6ab00', bg: '#000000' },
			s3: { text: '街を彩り、デザインする。', color: '#ffffff', bg: '#000000' },
			s4: { text: '', color: '#f6ab00', bg: '#000000' },
			s5: { text: 'Design It.', color: '#000000', bg: '#f6ab00' },
			s6: { text: '', color: '#f6ab00', bg: '#000000' }
		},
		{
			s1: { text: '彩る。', color: '#ffffff', bg: '#000000' },
			s2: { text: '', color: '#f6ab00', bg: '#000000' },
			s3: { text: '街を彩り、デザインする。', color: '#ffffff', bg: '#000000' },
			s4: { text: '', color: '#f6ab00', bg: '#000000' },
			s5: { text: 'デザインする。', color: '#ffffff', bg: '#000000' },
			s6: { text: '', color: '#f6ab00', bg: '#000000' }
		}
	];

	var KEYS = ['s1', 's2', 's3', 's4', 's5', 's6'];

	function computeMatrix(w, h, pts) {
		var x0 = pts[0][0], y0 = pts[0][1];
		var x1 = pts[1][0], y1 = pts[1][1];
		var x2 = pts[2][0], y2 = pts[2][1];
		var x3 = pts[3][0], y3 = pts[3][1];

		var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3;
		var dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;

		var a, b, c, d, e, f, g, hh;
		if (Math.abs(dx3) < 1e-9 && Math.abs(dy3) < 1e-9) {
			a = x1 - x0; b = x2 - x1; c = x0;
			d = y1 - y0; e = y2 - y1; f = y0;
			g = 0; hh = 0;
		} else {
			var den = dx1 * dy2 - dx2 * dy1;
			g = (dx3 * dy2 - dx2 * dy3) / den;
			hh = (dx1 * dy3 - dx3 * dy1) / den;
			a = x1 - x0 + g * x1;
			b = x3 - x0 + hh * x3;
			c = x0;
			d = y1 - y0 + g * y1;
			e = y3 - y0 + hh * y3;
			f = y0;
		}

		var A = a / w, B = b / h, C = c;
		var D = d / w, E = e / h, F = f;
		var G = g / w, H2 = hh / h;

		return [A, D, 0, G, B, E, 0, H2, 0, 0, 1, 0, C, F, 0, 1];
	}

	function run(corners, patterns) {
		var slots = KEYS.map(function (key, i) {
			return { key: key, corners: corners[i] };
		});

		slots.forEach(function (slot) {
			var el = document.createElement('div');
			el.className = 'kv-slot';
			el.setAttribute('aria-hidden', 'true');
			container.appendChild(el);
			slot.el = el;
		});

		function applySlot(slot) {
			if (slot.el.style.display === 'none') return;
			var rect = container.getBoundingClientRect();
			var pxCorners = slot.corners.map(function (pt) {
				return [pt[0] / 100 * rect.width, pt[1] / 100 * rect.height];
			});
			slot.el.style.transform = 'none';
			var w = slot.el.offsetWidth || 1;
			var h = slot.el.offsetHeight || 1;
			var m = computeMatrix(w, h, pxCorners);
			slot.el.style.transform = 'matrix3d(' + m.map(function (n) { return n.toFixed(5); }).join(',') + ')';
		}

		function applyAll() {
			slots.forEach(applySlot);
		}

		function render(index) {
			var p = patterns[index];
			slots.forEach(function (slot) {
				var d = p[slot.key];
				slot.el.textContent = d.text;
				slot.el.style.color = d.color;
				slot.el.style.backgroundColor = d.bg;
				slot.el.style.display = d.text ? '' : 'none';
			});
			applyAll();
		}

		var current = 0;
		render(current);

		var dots = [];
		if (patterns.length > 1) {
			var nav = document.createElement('div');
			nav.className = 'kv-dots';
			nav.setAttribute('role', 'group');
			nav.setAttribute('aria-label', 'メインビジュアルの表示パターン切り替え');

			patterns.forEach(function (_, i) {
				var btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'kv-dot' + (i === 0 ? ' active' : '');
				btn.setAttribute('aria-label', (i + 1) + '番目のパターンを表示');
				btn.addEventListener('click', function () { goTo(i); });
				nav.appendChild(btn);
				dots.push(btn);
			});
			container.appendChild(nav);
		}

		function goTo(i) {
			current = i;
			render(current);
			dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
		}

		/* live-track the viewport size change instead of waiting for it to settle */
		var resizeScheduled = false;
		window.addEventListener('resize', function () {
			if (resizeScheduled) return;
			resizeScheduled = true;
			requestAnimationFrame(function () {
				applyAll();
				resizeScheduled = false;
			});
		});
	}

	function isValidConfig(cfg) {
		return cfg && Array.isArray(cfg.corners) && cfg.corners.length === 6 &&
			Array.isArray(cfg.patterns) && cfg.patterns.length > 0;
	}

	fetch('data/kv-config.json', { cache: 'no-store' })
		.then(function (res) { return res.ok ? res.json() : null; })
		.catch(function () { return null; })
		.then(function (cfg) {
			if (isValidConfig(cfg)) {
				run(cfg.corners, cfg.patterns);
			} else {
				run(DEFAULT_CORNERS, DEFAULT_PATTERNS);
			}
		});

})();
